import {computed, inject, Injectable, signal} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Comparison} from '../../../shared/enum/comparision.enum';
import {LocaleDatePipe} from '../../../shared/pipes/locale-date.pipe';
import {Filter} from '../../orders/data-access/interfaces/filter.interface';
import {BaseOrdersFilterService} from '../../orders/services/base-orders-filter.service';
import {
  BATCH_NUMBER,
  COMPLAINT_NUMBER,
  DELIVERY_NUMBER,
  DOCSEARCH,
  ORDER_NUMBER,
  PO_NUMBER,
  SHIPMENT_NUMBER,
} from '../../orders/constants/names';
import {INVOICE_NUMBER} from '../../finance/constants/names';
import {FilterProperties} from '../../../interfaces/filter-properties.interface';

@Injectable({
  providedIn: 'root',
})
export class SearchFilterService extends BaseOrdersFilterService {
  protected formBuilder = inject(FormBuilder);
  protected datePipe = inject(LocaleDatePipe);
  public readonly SEARCH_TERM = 'searchTerm';

  //CONST
  protected override get criteria(): {[key: string]: FilterProperties} {
    return {
      [PO_NUMBER]: {comparisonType: () => Comparison.CONTAINS},
      [ORDER_NUMBER]: {comparisonType: () => Comparison.CONTAINS},
      [BATCH_NUMBER]: {comparisonType: () => Comparison.CONTAINS},
      [INVOICE_NUMBER]: {comparisonType: () => Comparison.CONTAINS},
      [SHIPMENT_NUMBER]: {comparisonType: () => Comparison.CONTAINS},
      [COMPLAINT_NUMBER]: {comparisonType: () => Comparison.CONTAINS},
      [DELIVERY_NUMBER]: {comparisonType: () => Comparison.CONTAINS},
      [DOCSEARCH]: {comparisonType: () => Comparison.CONTAINS},
    };
  }

  // PROPS
  protected form: FormGroup = this.createForm();

  // STATE
  public currentFilter = signal<Filter[]>(this.exportFilter());
  public appliedFilterCount = computed(() => this.currentFilter()?.length);

  protected override formProperties() {
    return {
      [this.SEARCH_TERM]: '',
    };
  }

  public getSearchControl() {
    return this.getControl(this.SEARCH_TERM);
  }

  public override exportFilter(): Filter[] {
    if (!this.form) {
      this.createForm();
    }
    return Object.entries(this.criteria)
      .map(([key, props]) => {
        return {
          name: key,
          value: this.getSearchControl()?.value,
          comparisonType: props.comparisonType(),
        } as Filter;
      })
      .filter(this.isFilterSet.bind(this)) as Filter[];
  }
}
